export const listRegistrars = `
   query listRegistrars($filter: RegistrarsFilterInput, $limit: Int, $nextToken: String) {
       listRegistrars(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
             id
             name
             description
             website
             createdByUsername
             created
             updated
           }
       }
   }
`

export const getRegistrar = `
   query getRegistrar($id:ID!) {
          getRegistrar(id:$id) {
            id
            name
            description
            website
            createdByUsername
            created
            updated
         }
}`